import type { ContentOrderWithGames } from "@/types/content-order";
import type { GameWithRelations } from "@/types/game";

export interface ContentOrderGameRow {
  order: {
    id: string;
    name: string;
    slug?: string;
    description: string | null;
    display_order: number;
  };
  games: GameWithRelations[];
}

/**
 * Transform content orders with games into GameRow format for frontend display
 * Only includes active orders with published games
 */
export function organizeContentOrders(
  contentOrders: ContentOrderWithGames[]
): ContentOrderGameRow[] {
  return contentOrders
    .filter((order) => order.active)
    .map((order) => ({
      order: {
        id: order.id,
        name: order.name,
        slug: order.slug,
        description: order.description,
        display_order: order.display_order,
      },
      games: order.games
        .filter((og) => og.game?.published)
        .sort((a, b) => a.display_order - b.display_order)
        .map((og) => og.game!),
    }))
    .filter((order) => order.games.length > 0)
    .sort((a, b) => a.order.display_order - b.order.display_order);
}
